/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

import * as overrides from '../../operation-overrides/getEvaluationsUsageOverrides';

export type GetEvaluationsUsagePathParams = NonNullable<operations['getEvaluationsUsage']['parameters']['path']>;

export type GetEvaluationsUsageQueryParams = NonNullable<operations['getEvaluationsUsage']['parameters']['query']>;

export interface Input extends GetEvaluationsUsagePathParams {
  apiVersion?: string;
  query?: GetEvaluationsUsageQueryParams;
}

export async function getEvaluationsUsage(
  { apiVersion, query, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().GET('/api/v2/usage/evaluations/{projectKey}/{environmentKey}/{featureFlagKey}', {
    params: { path, query },
    headers: mergeHeaders(headers, { 'LD-API-Version': apiVersion ?? overrides.apiVersion }),
    signal,
  });
}
